import log from 'loglevel';

import { createApiWithAuth } from '../utils/axios';

interface TextFormatterRequest {
  text: string;
  instruction: string;
}

interface TextFormatterResponse {
  success: boolean;
  formattedText?: string;
  error?: string;
}

let aiApi: ReturnType<typeof createApiWithAuth> | null = null;

const getAiApi = () => {
  if (!aiApi) {
    const baseUrl = import.meta.env.VITE_AI_TEXT_FORMATTER_BASE_URL;

    if (!baseUrl) {
      throw new Error('AI text formatter base URL is not set');
    }

    aiApi = createApiWithAuth(baseUrl);
  }
  return aiApi;
};

const handleRequestError = (context: string, error: unknown) => {
  log.error(`AI Service Error [${context}]:`, error);
  throw error;
};

export const formatTextWithAI = async (
  text: string,
  instruction: string,
): Promise<string> => {
  try {
    const requestBody: TextFormatterRequest = {
      text,
      instruction,
    };

    const { data } = await getAiApi().post('/', requestBody);

    const responseData: TextFormatterResponse = data.message || data;

    if (responseData.success && responseData.formattedText) {
      return responseData.formattedText;
    }

    throw new Error(responseData.error || 'Unknown error processing text');
  } catch (error) {
    handleRequestError('format text', error);
    throw error;
  }
};
